import { Link } from "react-router-dom";
import { KanbanSquare, LogOut, RefreshCw, SlidersHorizontal, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

/** Logo, refresh/sign-out and the three top-level views. */
export const DashboardHeader = ({
  view,
  onViewChange,
  refreshing,
  onRefresh,
  onSignOut,
  goneQuiet,
}) => (
  <header className="border-b border-border bg-white">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6">
      <div className="flex items-center gap-4">
        <Link to="/">
          <img src="/ttite-logo.png" alt="T-TITE" className="h-10 w-auto" />
        </Link>
        <div>
          <h1 className="text-lg font-bold leading-tight text-foreground">
            Pricing calculator dashboard
          </h1>
          <p className="text-xs text-muted-foreground">
            Every session, lead and fallback request — staff only
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={onRefresh}
          disabled={refreshing}
          data-testid="admin-refresh-button"
          className="h-10"
        >
          <RefreshCw
            className={`mr-2 h-4 w-4 ${refreshing ? "animate-spin" : ""}`}
            aria-hidden="true"
          />
          Refresh
        </Button>
        <Button
          type="button"
          variant="ghost"
          onClick={onSignOut}
          data-testid="admin-logout-button"
          className="h-10"
        >
          <LogOut className="mr-2 h-4 w-4" aria-hidden="true" />
          Sign out
        </Button>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-4 pb-3 sm:px-6">
      <Tabs value={view} onValueChange={onViewChange} className="max-w-full overflow-x-auto">
        <TabsList data-testid="admin-view-tabs" className="w-max">
          <TabsTrigger value="overview" data-testid="admin-view-overview">
            <Users className="mr-2 hidden h-4 w-4 sm:inline-block" aria-hidden="true" />
            Overview
          </TabsTrigger>
          <TabsTrigger value="board" data-testid="admin-view-board">
            <KanbanSquare className="mr-2 hidden h-4 w-4 sm:inline-block" aria-hidden="true" />
            Follow-up board
            {goneQuiet ? (
              <span
                data-testid="admin-view-board-badge"
                className="ml-2 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-[color:var(--tt-warn-bg)] px-1.5 font-amount text-[11px] font-bold text-[color:var(--tt-warn-text)]"
              >
                {goneQuiet}
              </span>
            ) : null}
          </TabsTrigger>
          <TabsTrigger value="rates" data-testid="admin-view-rates">
            <SlidersHorizontal
              className="mr-2 hidden h-4 w-4 sm:inline-block"
              aria-hidden="true"
            />
            Rate card
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  </header>
);
